import React, { useEffect, useState } from 'react';
import { Box, Link, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

export default function AccessibilityProvider({ children }) {
  const [showHelp, setShowHelp] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      // Focus global search with '/'
      if (e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey) {
        const el = document.getElementById('global-search');
        if (el) { e.preventDefault(); el.focus(); }
      }
      // Show shortcuts help with '?' (Shift+/)
      if (e.key === '?' || (e.key === '/' && e.shiftKey)) {
        setShowHelp(true);
      }
      // Close help with Escape
      if (e.key === 'Escape') setShowHelp(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      {children}

      <Dialog open={showHelp} onClose={() => setShowHelp(false)} aria-labelledby="shortcuts-help-title">
        <DialogTitle id="shortcuts-help-title">Keyboard Shortcuts</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Useful shortcuts:
            <ul>
              <li><strong>/</strong> — Focus global search</li>
              <li><strong>?</strong> — Show this shortcuts help</li>
              <li><strong>Esc</strong> — Close dialogs or help</li>
            </ul>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowHelp(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
